import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-piliang-h",
  "use": "icon-piliang-h-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-piliang-h\"><path fill=\"currentColor\" d=\"M512 96L256 256v128h512V256L512 96zM288 288l224-128 224 128H288z\" /><path fill=\"currentColor\" d=\"M288 416H256v512h512V416H288zM320 448h384v448H320V448z\" /><path fill=\"currentColor\" d=\"M192 352L128 416v448h512V416h-32v416H160V448h32V384h-32z\" /><rect fill=\"currentColor\" x=\"384\" y=\"544\" width=\"256\" height=\"32\" rx=\"4\" /><rect fill=\"currentColor\" x=\"384\" y=\"640\" width=\"256\" height=\"32\" rx=\"4\" /><rect fill=\"currentColor\" x=\"384\" y=\"736\" width=\"160\" height=\"32\" rx=\"4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/piliang-h.svg
// module id = O15P
// module chunks = 101